// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleBloc_container__VP7Kc","Main":"TitleBloc_Main__EQjdY","Number":"TitleBloc_Number__V-pSc","Image":"TitleBloc_Image__3Qh8K"};